"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CordovaJsonLoader = void 0;
var CordovaJsonLoader = /** @class */ (function () {
    function CordovaJsonLoader(_path, _onCompleteCb) {
        this._path = _path;
        this._onCompleteCb = _onCompleteCb;
        this._path = _path;
        this._onCompleteCb = _onCompleteCb;
    }
    CordovaJsonLoader.prototype.load = function () {
        var _this = this;
        window.resolveLocalFileSystemURL(cordova.file.applicationDirectory + "www" + "/" + this._path, function (fileEntry) {
            fileEntry.file(function (file) {
                var reader = new FileReader();
                reader.onloadend = function () { return _this.success(reader.result); };
                reader.readAsText(file);
            }, _this.error.bind(_this));
        }, this.error.bind(this));
    };
    CordovaJsonLoader.prototype.success = function (result) {
        try {
            this._onCompleteCb(JSON.parse(result), false);
        }
        catch (_a) {
            this._onCompleteCb("Failed to JSON parse file", true);
        }
    };
    CordovaJsonLoader.prototype.error = function (error) {
        var errorMessage = "Cordova Error Code: " + error.code;
        this._onCompleteCb(errorMessage, true);
    };
    return CordovaJsonLoader;
}());
exports.CordovaJsonLoader = CordovaJsonLoader;
